module.exports = __webpack_public_path__ + "static/media/tree.ba8e2983.svg";